module.exports = __webpack_public_path__ + "media/images/application/template/logo-66583949067fed1939d61b3280e1c552.svg";